import { useSyncExternalStore } from "react";

const tenantHostSuffixes = [".app.veronics.localhost", ".veronics.org"];
const reservedSiteSlugs = new Set(["admin", "api", "app", "assets", "localhost", "mail", "www", "veronics"]);
const siteSlugPattern = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export const isTenantOrganizationSiteHost = (host: string) => {
  const normalizedHost = host.trim().replace(/\.$/, "").toLowerCase();
  const suffix = tenantHostSuffixes.find((candidate) => normalizedHost.endsWith(candidate));

  if (!suffix) {
    return false;
  }

  const siteSlug = normalizedHost.slice(0, -suffix.length);
  return siteSlugPattern.test(siteSlug) && !reservedSiteSlugs.has(siteSlug);
};

const subscribeToHostChanges = () => () => undefined;
const getServerTenantHostSnapshot = () => false;
const getBrowserTenantHostSnapshot = () => isTenantOrganizationSiteHost(window.location.hostname);

export const useIsTenantOrganizationSiteHost = (getTenantHostSnapshot: () => boolean = getBrowserTenantHostSnapshot) =>
  useSyncExternalStore(subscribeToHostChanges, getTenantHostSnapshot, getServerTenantHostSnapshot);
